module.exports = __webpack_public_path__ + "1b0521b3e4f85a891384d0ed9e9a5c02.png";